export default __webpack_public_path__ + "static/media/princev.473b028b.png";